import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLinkedin, faGithub } from '@fortawesome/free-brands-svg-icons'
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import './Profile.css';
import Greeting from './Greeting'; 

const ProfileInfo = () => {
    return (
        <div className="profile-info">
            <img src="/media/charlotte.jpg" alt="" className="profile-image" />
            <br></br>         
            <a href="https://linkedin.com/in/charlottevmcknight" className="contact-link" title="Charlotte's LinkedIn">
                <FontAwesomeIcon icon={faLinkedin} />
            </a> 
            <a href="https://github.com/charlotteswebdev" className="contact-link" title="Charlotte's GitHub">
                <FontAwesomeIcon icon={faGithub} />
            </a>
            <a href="mailto:charlottevmcknight@gmail.com" className="contact-link" title="Email Charlotte">
                <FontAwesomeIcon icon={faEnvelope} />
            </a>
        </div>
    );
}

class Profile extends Component {
    render() {
        return (
            <div className="profile-container">
                <Greeting />
                <ProfileInfo />
            </div>
        );
    }
}


export default Profile;